// utils/jsonProcessors.js
import { MessageServices } from '../zod';
import { processContractAnalysisData } from './contractAnalysisWorkflow/processFullContractAnalysis';
import { processFullTxnDecode } from './decoderWorkflow/processFullTxnDecode';
import { processDecoderTraceCall } from './decoderWorkflow/processTraceCalll';
import { createDefaultMessages } from './defaultWorkflow/defaultUserPrompt';
import { processTracerNextNode } from './tracerWorkflows/processTracerNextNode';
import { processFullWalletProfile } from './walletProfileWorkflow/processFullProfile';
import { processKYCWalletProfile } from './walletProfileWorkflow/processKYC';

/**
 * Process JSON data based on action plan type and create messages
 * @param {Array} jsonFiles - Array of JSON file objects
 * @param {Object} currentPlan - Current action plan
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing processed JSON files and messages
 */
export const workflowToChatMessages = (
  jsonFiles,
  currentPlan,
  input,
  uploadedImages
) => {
  let processedJsonFiles = [...jsonFiles];
  let messages = null;

  if (!currentPlan || !currentPlan.name) {
    messages = createDefaultMessages(processedJsonFiles, input, uploadedImages);
    return {
      processedJsonFiles,
      messages,
    };
  }

  const messageService = MessageServices.parse(currentPlan.name);

  // Process based on action plan name
  switch (messageService) {
    case '1-full-wallet-profile': {
      const result = processFullWalletProfile(jsonFiles, input, uploadedImages);
      processedJsonFiles = result.processedJsonFiles;
      messages = result.messages;
      break;
    }

    case '2-wallet-kyc': {
      const result = processKYCWalletProfile(jsonFiles, input, uploadedImages);
      processedJsonFiles = result.processedJsonFiles;
      messages = result.messages;
      break;
    }
    case '3-analyze-txn-trace-call': {
      const result = processDecoderTraceCall(jsonFiles, input, uploadedImages);
      processedJsonFiles = result.processedJsonFiles;
      messages = result.messages;
      break;
    }

    case '4-full-txn-decode': {
      const result = processFullTxnDecode(jsonFiles, input, uploadedImages);
      processedJsonFiles = result.processedJsonFiles;
      messages = result.messages;
      break;
    }

    case '5-full-contract-analysis': {
      const result = processContractAnalysisData(
        jsonFiles,
        input,
        uploadedImages
      );
      processedJsonFiles = result.processedJsonFiles;
      messages = result.messages;
      break;
    }
    case '6-tracer-next-node': {
      const result = processTracerNextNode(jsonFiles, input, uploadedImages);
      processedJsonFiles = result.processedJsonFiles;
      messages = result.messages;
      break;
    }
    default: {
      messages = createDefaultMessages(
        processedJsonFiles,
        input,
        uploadedImages
      );
      break;
    }
  }

  return {
    processedJsonFiles,
    messages,
  };
};
